import React, { useEffect, useState } from "react";

import { getStaleTransactions } from "@/services/Orders.ts";
import { useTranslation } from "react-i18next";
import Spinner from "@/components/atoms/Spinner/Spinner.tsx";

import "./StaleTransactions.css";
import dayjs from "dayjs";

export default function StaleTransactions() {
  const { t } = useTranslation();

  const [staleTransactions, setStaleTransactions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    async function asyncInitiateStaleTransactions() {
      setIsLoading(true);
      const staleTrans = await getStaleTransactions();
      setStaleTransactions(staleTrans.data);
      setIsLoading(false);
    }

    asyncInitiateStaleTransactions().then();
  }, []);

  return (
    <>
      <Spinner loading={isLoading} inline={true} />
      <div className="stale-transactions-container flex">
        <table className="compact break-word">
          <thead>
            <tr>
              <th scope="col">{t("staleTransactions:dateTime")}</th>
              <th scope="col">{t("common:id")}</th>
              <th scope="col">{t("dashboard:status")}</th>
              <th scope="col">{t("staleTransactions:salesItem")}</th>
              <th scope="col">{t("common:amount")}</th>
              <th scope="col">{t("common:price")}</th>
              <th scope="col">{t("orders:buyer")}</th>
              <th scope="col">{t("orders:seller")}</th>
            </tr>
          </thead>
          <tbody>
            {staleTransactions.map((trans, index) => (
              <tr id={`trans-row-${index}`} key={`table-${index}`}>
                <td data-label={t("staleTransactions:dateTime")}>
                  {dayjs(trans.transactionDate).format("DD.MM.YYYY hh:mm")}
                </td>
                <td data-label="Id">{trans.id}</td>
                <td data-label={t("dashboard:status")}>
                  {t("enumerables:orderStatus." + trans.status.toUpperCase()).toUpperCase()}
                </td>
                <td data-label={t("staleTransactions:salesItem")}>
                  {t("enumerables:plastic." + trans.buyOrder.salesItem.salesItem)}
                </td>
                <td data-label={t("common:amount")}>
                  {trans.amount} {trans.buyOrder.unit.unit}
                </td>
                <td data-label={t("common:price")}>
                  {trans.buyOrder.priceWithFee[trans.buyOrder.orderCurrency]} {trans.buyOrder.orderCurrency}
                </td>
                <td data-label={t("orders:buyer")}>{trans.buyerCompany.companyName}</td>
                <td data-label={t("orders:seller")}>{trans.sellerCompany.companyName}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
